import React from "react";
import classes from './BreedingAchievementsDocumet.module.scss'
import Document from "../../../../components/Document";
export default function BreedingAchievementsDocumet() {
    return(
        <Document/>

    )
    
}